export default "b3c0507a25ead307.woff2"